export default __webpack_public_path__ + "media/images/react_icons/property/cutlery-bcf13014482d1d8f29de213174410b94.svg";